<template>
  <el-dialog title="出库检索" :visible.sync="dialogVisible" width="1280px" @closed="reset">
    <div class="search-bar">
      <div class="search-item">
        <span class="search-label">SKU</span>
        <el-input v-model="form.sku" size="small" clearable placeholder="请输入SKU" class="search-input" @keyup.enter.native="handleSearch"></el-input>
      </div>
      <div class="search-item">
        <span class="search-label">Asin</span>
        <el-input v-model="form.asin" size="small" clearable placeholder="请输入Asin" class="search-input" @keyup.enter.native="handleSearch"></el-input>
      </div>
      <div class="search-item">
        <span class="search-label">状态</span>
        <el-select v-model="form.statusList" size="small" multiple collapse-tags clearable placeholder="全部" class="search-status">
          <el-option label="出库中" :value="1"></el-option>
          <el-option label="已出库" :value="2"></el-option>
          <el-option label="出库完成" :value="3"></el-option>
          <el-option label="已拆分" :value="4"></el-option>
          <el-option label="已作废" :value="-1"></el-option>
        </el-select>
      </div>
      <div class="search-item">
        <span class="search-label">创建日期</span>
        <el-date-picker v-model="form.dateRange" type="daterange" size="small" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable></el-date-picker>
      </div>
      <div class="search-item">
        <span class="search-label">货件类型</span>
        <el-select v-model="form.shipmentType" size="small" clearable placeholder="全部" class="search-shipment">
          <el-option label="全部" value=""></el-option>
          <el-option label="FBA货件" :value="1"></el-option>
          <el-option label="AWD货件" :value="2"></el-option>
        </el-select>
      </div>
      <el-button type="primary" size="small" icon="el-icon-search" :loading="loading" @click="handleSearch">查询</el-button>
    </div>

    <el-table ref="table" :data="list" border stripe size="mini" max-height="420" show-summary :summary-method="getSummaries" v-loading="loading" element-loading-text="加载中...">
      <el-table-column label="序号" width="60" align="center">
        <template slot-scope="scope">
          {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="date" label="创建日期" width="110" align="center"></el-table-column>
      <el-table-column prop="shopName" label="店铺" width="80" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="planId" label="出库计划编号" width="130" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column label="出库状态" width="90" align="center">
        <template slot-scope="scope">
          <el-tag size="mini" :type="getStatusTagType(scope.row.status)" effect="light">
            {{ getStatusLabel(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="boxCount" label="箱子数" width="70" align="right"></el-table-column>
      <el-table-column prop="skuCount" label="SKU数" width="70" align="right"></el-table-column>
      <el-table-column prop="productCount" label="商品数" width="70" align="right"></el-table-column>
      <el-table-column label="货件类型" width="90" align="center">
        <template slot-scope="scope">
          {{ getShipmentTypeLabel(scope.row.shipmentType) }}
        </template>
      </el-table-column>
      <el-table-column prop="sku" label="SKU" min-width="180" show-overflow-tooltip></el-table-column>
      <el-table-column prop="asin" label="Asin" width="130" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="outStockCount" label="出库数量" width="90" align="right"></el-table-column>
    </el-table>

    <div class="search-pagination">
      <el-pagination background layout="total, prev, pager, next" :current-page="currentPage" :page-size="pageSize" :total="total" @current-change="handlePageChange"></el-pagination>
    </div>
  </el-dialog>
</template>

<script>
import { requestModules } from "@r";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        sku: "",
        asin: "",
        statusList: [1, 2],
        dateRange: [],
        shipmentType: 1
      },
      list: [],
      total: 0,
      totalOutStockCount: 0,
      currentPage: 1,
      pageSize: 50,
      loading: false,
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
  },
  methods: {
    handleSearch() {
      this.currentPage = 1;
      this.fetchList();
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchList();
    },
    fetchList() {
      const sku = (this.form.sku || "").trim();
      const asin = (this.form.asin || "").trim();
      if (!sku && !asin) {
        this.$message.warning("请输入 SKU 或 Asin");
        return;
      }
      const dateRange = this.form.dateRange || [];
      this.loading = true;
      requestModules
        .fetchOutStockPlanSkuSearch({
          sku,
          asin,
          statusList: this.form.statusList,
          shipmentType: this.form.shipmentType,
          beginDate: dateRange[0] || "",
          endDate: dateRange[1] || "",
          beginIndex: (this.currentPage - 1) * this.pageSize,
          pageSize: this.pageSize,
        })
        .then(res => {
          this.list = res.ldata || [];
          this.total = res.total || 0;
          const count = res.mdata && res.mdata.outStockCount;
          this.totalOutStockCount = count == null ? 0 : count;
          this.loading = false;
          this.layoutTable();
        })
        .catch(err => {
          this.loading = false;
          if (err && err.result === 0 && err.message) {
            this.$message.error(err.message);
          }
        });
    },
    getSummaries({ columns }) {
      return columns.map((column, index) => {
        if (index === 0) return "合计";
        if (column.property === "outStockCount") return this.totalOutStockCount;
        return "";
      });
    },
    layoutTable() {
      this.$nextTick(() => {
        if (this.$refs.table) this.$refs.table.doLayout();
      });
    },
    getShipmentTypeLabel(shipmentType) {
      return shipmentType == 2 ? "AWD货件" : "FBA货件";
    },
    getStatusLabel(status) {
      if (status == 1) return "出库中";
      if (status == 2) return "已出库";
      if (status == 3) return "出库完成";
      if (status == 4) return "已拆分";
      if (status == -1) return "已作废";
      return "";
    },
    getStatusTagType(status) {
      if (status == 1) return "warning";
      if (status == 2) return "primary";
      if (status == 3) return "success";
      if (status == 4) return "info";
      if (status == -1) return "danger";
      return "info";
    },
    reset() {
      this.form = {
        sku: "",
        asin: "",
        statusList: [1, 2],
        dateRange: [],
        shipmentType: 1
      };
      this.list = [];
      this.total = 0;
      this.totalOutStockCount = 0;
      this.currentPage = 1;
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.search-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 12px;
  margin-bottom: 12px;
}

.search-item {
  display: flex;
  align-items: center;
}

.search-label {
  margin-right: 8px;
  color: #606266;
  white-space: nowrap;
}

.search-input {
  width: 180px;
}

.search-status {
  width: 180px;
}

.search-shipment {
  width: 140px;
}

.search-pagination {
  margin-top: 12px;
  text-align: right;
}
</style>
